/* Copyright (c) 2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { useAzureOnboardingScriptQuery } from "~/generated/graphql";

export function useGetAzureOnboardingScript(subscriptionId: string) {
  const { data, error } = useAzureOnboardingScriptQuery({
    variables: {
      subscriptionId: subscriptionId,
    },
  });
  return { azureOnboardingScript: data?.azureOnboardingScript, error } as const;
}
